// extracted by mini-css-extract-plugin
export default {"form":"Auth_form__HZx9W","orSpan":"Auth_orSpan__qyzCD"};